import { useState, useMemo, useEffect } from "react";
import MaterialReactTableWithSearch from "../../../components/MaterialReactTable/MaterialReactTableWithSearch";
import { Box, IconButton, Tooltip, Card, Grid, CardContent, Chip } from "@mui/material";
import Person4OutlinedIcon from '@mui/icons-material/Person4Outlined';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Update as UpdateIcon } from '@mui/icons-material';
import { useData } from "../../../context/DataContext";
import { APP_ROUTES } from "../../../config/appRoutes";
import { useNavigate } from 'react-router-dom';
import moment from "moment";
import { deleteTrainingSession } from '../../../context/createAPI';
import TraningSessionStatusUpdateModal from "../TraningSessionStatusUpdateModal/TraningSessionStatusUpdateModal";
import SingleSelect from "../../../components/Selections/singleSelect";
import MultiSelectWithAll from "../../../components/Selections/multiSelectWithAll";
import SnackbarMessage from "../../../components/snackBar/snackBar";

import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';

function TrainingSessionHistory() {
  const { trainingStatus = [], trainingSessions = [], handleTrainingSessions, years = [], levels = [], user = {}, handleAttendance, trainingTypes = []} = useData();
 
  const customOrder = [2, 1, 3];
  const trainingSessionStatusWiseSort = trainingSessions.sort((a, b) => {
    return customOrder.indexOf(a.training_Status_id) - customOrder.indexOf(b.training_Status_id);
  });


  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const navigate = useNavigate();
  const [yearId, setYearId] = useState(null);
  const [levelId, setLevelId] = useState(null);
  const [trainingTypeId, setTrainingTypeId] = useState("0");

  const [state, setState] = useState({
    selectedStatusValue: [],
    filterStatusDetails: [],
    filteredSessions: [],
    filterStatusSessionData: [],
    isStatusFilter: false,
    statusUpdateModal: false,
    statusRowData: {},
    sessionUpdateDate: false,
    selectedSessionDateRange: [
      dayjs(),            // today
      dayjs().add(10, "day") // +10 days
    ],
  });


  useEffect(() => {
    if (years?.length > 0) {
      setYearId(years[0]?.value);
    }

    if (levels?.length > 0) {
      setLevelId(levels[0]?.value)
    }

    if (trainingTypes?.length > 0) {
      setTrainingTypeId(trainingTypes[0].value);
    }
  }, [years, levels,]);




  const columns = useMemo(() => [
    { accessorFn: (_, index) => index + 1, header: 'SNO', id: 'id', size: 50, minSize: 20 },
    {
      accessorKey: "training_type",
      header: "Training Type",
      Cell: ({ row }) => {
        const text =
          row.original.training_type != null
            ? row.original.training_type
            : "-";
        return (
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "150px",
              cursor: "pointer",
            }}
          >
            <Tooltip title={text} arrow>
              <span
                style={{
                  display: "inline-block",
                  maxWidth: "150px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {text}
              </span>
            </Tooltip>
          </div>
        );
      },
    },
    {
      accessorKey: "training_content",
      header: 'Training Content',
      size: 80, minSize: 50,
      Cell: ({ row }) => (
        <Tooltip title={row.original.training_content || "-"} arrow>
          <button
            style={{ backgroundColor: "transparent", border: "none", cursor: "pointer", color: "blue", textDecoration: "underline" }}
            onClick={() => handleRowClick(row)}
          >
            {row.original.training_content || "-"} ({moment.unix(row.original.month_of_training).format('MM/YYYY')})
          </button>
        </Tooltip>
      ),
    },
    levelId === 1 || levelId === "1"
      ? { accessorKey: "village_name", header: "Village Name", Cell: ({ row }) => row.original.village_names || "-" }
      : { accessorKey: "group_name", header: "Group Name", Cell: ({ row }) => row.original.group_names || "-" },
    {
      accessorKey: "training_status",
      header: 'Status',
      Cell: ({ row }) => {
        const status = row.original.training_status || "";
        const colorMap = {
          completed: "success",
          inprocess: "warning",
          created: "info",
        };
        const chipColor = colorMap[status.toLowerCase()] || "default";

        return <Chip label={status} color={chipColor} size="small" />;
      },
    },
    {
      accessorKey: "session_date",
      header: 'Session Date',
      Cell: ({ row }) =>
        <div style={{ cursor: row.original.training_Status_id === 3 ? "" : "pointer" }} onClick={() => setState(prevState => ({
          ...prevState,
          sessionUpdateDate: row.original.training_Status_id === 3 ? false : true,
          statusRowData: row.original,
        }))}>
          {
            row.original.training_Status_id === 3 ? <div>{row.original.session_date ? moment.unix(row.original.session_date).format('DD/MMM/YYYY hh:mm') : "-"}</div> : <Tooltip title="Update Session Date">{row.original.session_date ? moment.unix(row.original.session_date).format('DD/MMM/YYYY hh:mm') : "-"}</Tooltip>
          }
        </div>,
    }
  ], [levelId]);


  const handleFeedBack = (row) => navigate(`${APP_ROUTES?.TRAININGSESSION?.HISTORY_ROUTES.FEEDBACK}`, { state: { rowData: row.original } });

  const handleRowClick = async (row) => {
    const attendanceId = row.original?.id;
    await handleAttendance(attendanceId);
    navigate(`${APP_ROUTES?.TRAININGSESSION?.HISTORY_ROUTES.SISSIONPLAN_HISTORY}`, {
      state: { rowData: row.original }
    })
  };

  const handleDelete = async (row) => {
    if (window.confirm(`Are you sure you want to delete this "${row.original.training_content}"?`)) {
      try {
        const { statusCode, data } = await deleteTrainingSession({ id: row.original.id });
        if (statusCode === 200) {
          handleTrainingSessions();
          setSnackbar({
            open: true,
            message: data ?? "Training Session deleted successfully",
            severity: "success",
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleAttendancerow = async (row) => {

    const attendanceId = row.original?.id;
    await handleAttendance(attendanceId);
    navigate(`${APP_ROUTES?.TRAININGSESSION?.HISTORY_ROUTES.ATTENDANCE}`, {
      state: {
        rowData: row.original,
      }
    })
  };

  const [, setDisabledButton] = useState(false);

  useEffect(() => {
    const hasActiveSession = trainingSessionStatusWiseSort.some((item) => {
      if (item.training_Status_id === 3) {
        const sessionTime = parseInt(item.session_date);
        return Date.now() - sessionTime * 1000 <= 24 * 60 * 60 * 1000;
      }
    });
    setDisabledButton(!hasActiveSession);
  }, [trainingSessionStatusWiseSort]);

  const renderRowActions = ({ row }) => {

    return (
      <Box sx={{ display: "flex", gap: 1 }}>
        <Tooltip title="Attendance">
          <IconButton
            onClick={() => handleAttendancerow(row)}
            disabled={
              row.original.training_Status_id === 1 ||
              row.original.training_Status_id === 3 ||
              row.original.training_type_id === 2
            }
          >
            <Person4OutlinedIcon
              sx={{
                color:
                  row.original.training_Status_id === 1 ||
                    row.original.training_type_id === 2 ||
                    row.original.training_Status_id === 3
                    ? "text.disabled"
                    : "var(--success)",
              }}
            />
          </IconButton>
        </Tooltip>

        <Tooltip title="Feedback">
          <IconButton
            onClick={() => handleFeedBack(row)}
            disabled={
              row.original.training_Status_id === 1 ||
              row.original.training_Status_id === 3
            }
          >
            <ChatOutlinedIcon
              sx={{
                color:
                  row.original.training_Status_id === 1 || row.original.training_Status_id === 3
                    ? "text.disabled"
                    : "var(--active-color)",
              }}
            />
          </IconButton>
        </Tooltip>

        <Tooltip title="Delete">
          <IconButton
            onClick={() => handleDelete(row)}
            disabled={
              row.original.training_Status_id === 3 ||
              row.original.training_Status_id === 2
            }
          >
            <DeleteOutlineIcon
              sx={{
                color:
                  row.original.training_Status_id === 3 ||
                    row.original.training_Status_id === 2
                    ? "text.disabled"
                    : "error.main",
              }}
            />
          </IconButton>
        </Tooltip>

        <Tooltip title="Status">
          <IconButton
            onClick={() => handleSessionStatus(row)}
            disabled={row.original.training_Status_id === 3}
          >
            <UpdateIcon
              sx={{
                color:
                  row.original.training_Status_id === 3
                    ? "text.disabled"
                    : "var(--secondary)",
              }}
            />
          </IconButton>
        </Tooltip>
      </Box>
    )
  };

  const handleSessionStatus = (row) => setState((prevState) => ({ ...prevState, statusUpdateModal: true, statusRowData: row.original }));

  const handleClose = () => setState((prevState) => ({ ...prevState, statusUpdateModal: false, sessionUpdateDate: false }));

  const statusCount = useMemo(() => {
    return state.filterStatusSessionData.reduce((acc, { training_Status_id }) => {
      acc[training_Status_id] = (acc[training_Status_id] || 0) + 1;
      return acc;
    }, {});
  }, [state.filterStatusSessionData]);

  const statusOptions = useMemo(() => trainingStatus.map((status) => ({
    ...status,
    label: `${status.label} - ${statusCount[status.value] || 0}`
  })), [trainingStatus, statusCount]);


  useEffect(() => {
    setState(prevState => ({
      ...prevState,
      selectedStatusValue: statusOptions
    }))
  }, [statusOptions])


  const handleMultiselectChange = (name, selectedOptions) => {
    const selectedIds = selectedOptions.map((opt) => opt.value);
    const filteredStatusSessions = state.filterStatusSessionData.filter(({ training_Status_id }) => selectedIds.includes(training_Status_id));
    setState((prevState) => ({
      ...prevState,
      selectedStatusValue: selectedOptions,
      filteredSessions: filteredStatusSessions,
      isStatusFilter: true,
    }));
  };


  useEffect(() => {
    if (trainingTypeId !== 0 && trainingTypeId !== "") {
      setState((prevState) => ({
        ...prevState,
        filteredSessions: trainingSessionStatusWiseSort,
        isStatusFilter: true,
      }));
    }

    const filteredData = trainingSessionStatusWiseSort.filter(item =>
      (yearId === null || +item.year_id === +yearId) &&
      (levelId === null || +item.levelId === +levelId) &&
      (trainingTypeId == null || trainingTypeId === "0" || +item.training_type_id === +trainingTypeId)
    );


    setState((prevState) => ({
      ...prevState,
      filterStatusSessionData: filteredData,
      selectedStatusValue: [],
      filteredSessions: filteredData,
      isStatusFilter: false,
    }));

  }, [yearId, levelId, trainingTypeId, trainingSessionStatusWiseSort]);

  const handleInputChange = (name, value) => {
    if (name === "years") {
      setYearId(value);
    } else if (name === "levelId") {
      setLevelId(value);
    } else if (name === "trainingType") {
      if (value === "0") {
        setTrainingTypeId(+value);
        setState((prevState) => ({
          ...prevState,
          filteredSessions: trainingSessionStatusWiseSort,
          isStatusFilter: true,
        }));
      } else {
        setTrainingTypeId(+value);
      }
    }
  };

  return (
    <Box>
      <Card elevation={6}>
        <Box sx={{ p: 2 }}>
          <Grid container spacing={1}>
            {
              [
                { id: 1, name: "years", label: "Select year", value: yearId, options: years },
                { id: 2, name: "trainingType", label: "Select Type", value: trainingTypeId, options: trainingTypes },
                ...user?.user_level_id === 4 ? [] : [{ id: 3, name: "levelId", label: "Select Level", value: levelId, options: levels }],
                { id: 4, name: "selectedStatusValue", label: "Select Status", value: state.selectedStatusValue, options: statusOptions },
                { id: 5, value: state.selectedSessionDateRange }
              ].map((field) => (
                <Grid item size={{ xs: 12, md: user?.user_level_id === 4 ? user?.user_level_id === 4 && field.id === 5 ? 3 : 2 : field.id === 5 ? 4 : 2 }} mt={field.id !== 5 ?? 2}>
                  {
                    field.id === 4 ? (
                      <MultiSelectWithAll
                        name={field.name}
                        label={field.label}
                        options={field.options}
                        value={state[field.name] || []}
                        onChange={handleMultiselectChange}
                      />
                    ) : field.id === 5 ? (
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateRangePicker', 'DateRangePicker']}>
                          <DateRangePicker
                            localeText={{ start: 'Start Date', end: 'End Date' }}
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true
                              }
                            }}
                            sx={{ width: "100%" }}
                            value={field.value}
                            onChange={(newValue) => {
                              const [startDate, endDate] = newValue;

                              // update selected range in state
                              setState(prev => ({
                                ...prev,
                                selectedSessionDateRange: newValue
                              }));

                              if (startDate && endDate) {
                                const startUnix = startDate.startOf("day").unix();
                                const endUnix = endDate.endOf("day").unix();

                                const filtered = trainingSessionStatusWiseSort.filter(item => {
                                  const sessionUnix = Number(item.session_date);
                                  return sessionUnix >= startUnix && sessionUnix <= endUnix;
                                });

                                setState(prev => ({
                                  ...prev,
                                  filterStatusSessionData: filtered
                                }));
                              }
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    ) : (
                      <SingleSelect
                        name={field.name}
                        label={field.label}
                        options={field.options}
                        value={field.value}
                        onChange={handleInputChange}
                      />
                    )
                  }
                </Grid>
              ))
            }
          </Grid>
        </Box>

        <CardContent>
          <MaterialReactTableWithSearch
            data={state.isStatusFilter === true ? state.filteredSessions : state.filterStatusSessionData}
            columns={columns}
            enableRowActions={user?.user_level_id === 4 ? true : false}
            renderRowActions={user?.user_level_id === 4 ? renderRowActions : ""}
          />
        </CardContent>
      </Card>
      {state.statusUpdateModal || state.sessionUpdateDate ? <TraningSessionStatusUpdateModal handleClose={handleClose} show rowData={state.statusRowData} statusUpdate={state.statusUpdateModal} updateDate={state.sessionUpdateDate} /> : ""}

      <SnackbarMessage
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      />
    </Box>
  );
}
export default TrainingSessionHistory;